const React = require('react');
const PropTypes = require('prop-types');

const { useModuleContext } = require('./ModuleContext');

const { createContext, useContext, useMemo } = React;
/**
 * Context to use in your app to make it cross-admin translations compatible
 */
const I18nContext = createContext();

const I18nProvider = ({ i18n, children }) => React.createElement(I18nContext.Provider, {
  value: i18n,
}, children);

I18nProvider.propTypes = {
  i18n: PropTypes.shape().isRequired,
  children: PropTypes.node.isRequired,
};

/**
 * useI18n is a customHook that helps you to access your frontend-i18n instance and
 * that is aware of it's execution context. It uses frontend-remote-modules ModuleContext
 * to decide where to take the translations object from. It is useful when you develop
 * a component that will be rendered in multiple admins.
 * Note that it only creates the frontend-i18n instance when running in remote mode, to make
 * it easier to implement.
 */
const useI18n = () => {
  const moduleContext = useModuleContext();
  const localI18n = useContext(I18nContext);
  return useMemo(() => (moduleContext && moduleContext.i18n
    ? moduleContext.i18n : localI18n), [moduleContext, localI18n]);
};

const context = { I18nContext, I18nProvider, useI18n };

module.exports = context;
